/**
 * Platform detection for Fiddyscript (Electron vs web browser).
 * Use isWeb to hide desktop-only features or show alternate UI on the web version.
 */
export const isWeb =
  typeof window !== 'undefined' && !window.electronAPI;
